// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ReportSchema = z.object({
  id: z.number().int().gt(0),
  name: z.coerce.string().min(1),
  description: z.coerce.string().nullish(),
  widget_types: z.array(z.unknown()),
  from: z.string().datetime().nullish(),
  to: z.string().datetime().nullish(),
  span: z.coerce.string().min(1),
  updated_at: z.string().datetime().min(1),
  include_hours: z.boolean(),
  hour_fields: z.array(z.unknown()),
  task_fields: z.array(z.unknown()).nullish(),
  date_range: z.coerce.string().nullish(),
  user: z.optional(z.object({
    id: z.number().int().gt(0),
    email: z.coerce.string().min(1),
    name: z.coerce.string().min(1),
    avatar: z.object({
      large_retina: z.coerce.string().min(1),
      large: z.coerce.string().min(1),
      medium_retina: z.coerce.string().min(1),
      medium: z.coerce.string().min(1),
      timeline: z.coerce.string().min(1),
    }),
    updated_at: z.coerce.string().min(1),
  })),
});
